'use strict';

var MOBILE_BREAKPOINT = 768;

function FrontPageMobileMenu(options) {
  this.rootSelector = options.rootSelector;
  this.buttonSelector = options.buttonSelector;
  this.closeButtonSelector = options.closeButtonSelector;
  this.sidebarSelector = options.sidebarSelector;
  this.panelSelector = options.panelSelector;
  this.menuLinkSelector = options.menuLinkSelector;
  this.activeClass = options.activeClass;
  this.bodyClass = options.bodyClass;

  this.root = document.querySelector(this.rootSelector);
  this.button = this.root ? this.root.querySelector(this.buttonSelector) : null;
  this.sidebar = this.root ? this.root.querySelector(this.sidebarSelector) : null;
  this.panel = this.sidebar ? this.sidebar.querySelector(this.panelSelector) : null;
  this.closeButton = this.panel ? this.panel.querySelector(this.closeButtonSelector) : null;
  this.menuLinks = this.sidebar ? this.sidebar.querySelectorAll(this.menuLinkSelector) : [];
  this.submenuItemSelector = '.menu-item-has-children';
  this.submenuOpenClass = 'is-submenu-open';
  this.submenuIconClass = 'menu-item-submenu-icon';
  this.arrowDownSvgMarkup = this.normalizeSvgMarkup(
    window.aderbalData && window.aderbalData.arrowDownSolidSvg
      ? window.aderbalData.arrowDownSolidSvg
      : ''
  );
  this.timeline = null;
  this.isOpen = false;
  this.focusableElements = [];
  this.firstFocusableElement = null;
  this.lastFocusableElement = null;
  this.lastActiveElement = null;

  this.handleToggle = this.handleToggle.bind(this);
  this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
  this.handleSidebarPointerDown = this.handleSidebarPointerDown.bind(this);
  this.handleLinkClick = this.handleLinkClick.bind(this);
  this.handleResize = this.handleResize.bind(this);
}

FrontPageMobileMenu.prototype.init = function () {
  if (
    !this.root ||
    !this.button ||
    !this.sidebar ||
    !this.panel ||
    !this.closeButton ||
    !this.canAnimate()
  ) {
    return;
  }

  this.button.setAttribute('aria-expanded', 'false');
  this.button.setAttribute('aria-label', 'Abrir menu');
  this.sidebar.setAttribute('aria-hidden', 'true');

  this.buildTimeline();
  this.appendSubmenuIcons();
  this.prepareSubmenus();
  this.bindEvents();
};

FrontPageMobileMenu.prototype.normalizeSvgMarkup = function (markup) {
  var normalizedMarkup = typeof markup === 'string' ? markup : '';
  var textarea;

  if (!normalizedMarkup) {
    return '';
  }

  normalizedMarkup = normalizedMarkup
    .replace(/\\u003[cC]/g, '<')
    .replace(/\\u003[eE]/g, '>')
    .replace(/\\u0022/g, '"')
    .replace(/\\u0027/g, "'")
    .replace(/\\n/g, '')
    .trim();

  textarea = document.createElement('textarea');
  textarea.innerHTML = normalizedMarkup;
  normalizedMarkup = textarea.value.trim();

  return normalizedMarkup;
};

FrontPageMobileMenu.prototype.getDirectLink = function (menuItem) {
  var children;
  var index;

  if (!menuItem) {
    return null;
  }

  children = menuItem.children;

  for (index = 0; index < children.length; index += 1) {
    if (children[index].tagName === 'A') {
      return children[index];
    }
  }

  return null;
};

FrontPageMobileMenu.prototype.createSubmenuIcon = function () {
  var wrapper;
  var svg;

  if (!this.arrowDownSvgMarkup) {
    return null;
  }

  wrapper = document.createElement('div');
  wrapper.innerHTML = this.arrowDownSvgMarkup;
  svg = wrapper.querySelector('svg');

  if (!svg) {
    return null;
  }

  svg.classList.add(this.submenuIconClass);
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  return svg;
};

FrontPageMobileMenu.prototype.appendSubmenuIcons = function () {
  var submenuItems;
  var menuLink;
  var icon;
  var index;

  if (!this.root || !this.arrowDownSvgMarkup) {
    return;
  }

  submenuItems = this.root.querySelectorAll(this.submenuItemSelector);

  for (index = 0; index < submenuItems.length; index += 1) {
    menuLink = this.getDirectLink(submenuItems[index]);

    if (!menuLink || menuLink.querySelector('.' + this.submenuIconClass)) {
      continue;
    }

    icon = this.createSubmenuIcon();

    if (icon) {
      menuLink.appendChild(icon);
    }
  }
};

FrontPageMobileMenu.prototype.canAnimate = function () {
  return typeof window.gsap !== 'undefined';
};

FrontPageMobileMenu.prototype.bindEvents = function () {
  var index;

  this.button.addEventListener('click', this.handleToggle);
  this.closeButton.addEventListener('click', this.handleLinkClick);
  this.sidebar.addEventListener('click', this.handleSidebarPointerDown);
  document.addEventListener('keydown', this.handleDocumentKeydown);
  window.addEventListener('resize', this.handleResize, { passive: true });

  for (index = 0; index < this.menuLinks.length; index += 1) {
    this.menuLinks[index].addEventListener('click', this.handleLinkClick);
  }
};

FrontPageMobileMenu.prototype.buildTimeline = function () {
  this.timeline = window.gsap.timeline({
    paused: true,
    defaults: {
      duration: 0.45,
      ease: 'power3.out',
    },
    onStart: this.onOpenStart.bind(this),
    onReverseComplete: this.onCloseComplete.bind(this),
  });

  window.gsap.set(this.sidebar, {
    autoAlpha: 0,
    pointerEvents: 'none',
  });

  window.gsap.set(this.panel, {
    xPercent: 100,
  });

  if (this.menuLinks.length) {
    window.gsap.set(this.menuLinks, {
      autoAlpha: 0,
      x: 32,
    });
  }

  this.timeline.to(this.sidebar, {
    autoAlpha: 1,
    pointerEvents: 'auto',
    duration: 0.22,
    ease: 'power1.out',
  });

  this.timeline.to(
    this.panel,
    {
      xPercent: 0,
    },
    0
  );

  if (this.menuLinks.length) {
    this.timeline.to(
      this.menuLinks,
      {
        autoAlpha: 1,
        x: 0,
        stagger: 0.06,
        duration: 0.3,
      },
      0.12
    );
  }
};

FrontPageMobileMenu.prototype.handleToggle = function () {
  if (this.isOpen) {
    this.close();
    return;
  }

  this.open();
};

FrontPageMobileMenu.prototype.handleSidebarPointerDown = function (event) {
  if (!this.isOpen) {
    return;
  }

  if (event.target === this.sidebar) {
    this.close();
  }
};

FrontPageMobileMenu.prototype.handleDocumentKeydown = function (event) {
  if (!this.isOpen) {
    return;
  }

  if (event.key === 'Escape') {
    event.preventDefault();
    this.close();
    return;
  }

  if (event.key === 'Tab') {
    this.maintainFocus(event);
  }
};

FrontPageMobileMenu.prototype.handleLinkClick = function () {
  var link = arguments.length > 0 ? arguments[0].currentTarget : null;
  var event = arguments.length > 0 ? arguments[0] : null;

  if (link && this.toggleSubmenuForLink(link, event)) {
    return;
  }

  this.close();
};

FrontPageMobileMenu.prototype.handleResize = function () {
  if (window.innerWidth > MOBILE_BREAKPOINT && this.isOpen) {
    this.close(true);
  }
};

FrontPageMobileMenu.prototype.open = function () {
  if (this.isOpen) {
    return;
  }

  this.isOpen = true;
  this.lastActiveElement = document.activeElement;
  this.refreshFocusableElements();

  this.button.setAttribute('aria-expanded', 'true');
  this.button.setAttribute('aria-label', 'Fechar menu');
  this.sidebar.setAttribute('aria-hidden', 'false');
  this.root.classList.add(this.activeClass);
  document.body.classList.add(this.bodyClass);

  this.timeline.timeScale(1).play(0);

  if (this.firstFocusableElement) {
    this.firstFocusableElement.focus();
  }
};

FrontPageMobileMenu.prototype.close = function (skipAnimation) {
  if (!this.isOpen) {
    return;
  }

  this.isOpen = false;
  this.button.setAttribute('aria-expanded', 'false');
  this.button.setAttribute('aria-label', 'Abrir menu');
  this.sidebar.setAttribute('aria-hidden', 'true');
  this.root.classList.remove(this.activeClass);
  document.body.classList.remove(this.bodyClass);
  this.collapseSubmenus();

  if (skipAnimation) {
    this.timeline.pause(0);
    window.gsap.set(this.sidebar, {
      autoAlpha: 0,
      pointerEvents: 'none',
    });
    window.gsap.set(this.panel, {
      xPercent: 100,
    });

    if (this.menuLinks.length) {
      window.gsap.set(this.menuLinks, {
        autoAlpha: 0,
        x: 32,
      });
    }

    this.onCloseComplete();
    return;
  }

  this.timeline.timeScale(1.15).reverse();
};

FrontPageMobileMenu.prototype.onOpenStart = function () {
  this.sidebar.style.visibility = 'visible';
};

FrontPageMobileMenu.prototype.onCloseComplete = function () {
  if (this.lastActiveElement && typeof this.lastActiveElement.focus === 'function') {
    this.lastActiveElement.focus();
  }
};

FrontPageMobileMenu.prototype.refreshFocusableElements = function () {
  var selector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var elements = this.panel.querySelectorAll(selector);
  var filteredElements = [];
  var index;

  for (index = 0; index < elements.length; index += 1) {
    if (elements[index].offsetParent !== null) {
      filteredElements.push(elements[index]);
    }
  }

  this.focusableElements = filteredElements;
  this.firstFocusableElement = this.focusableElements[0] || this.button;
  this.lastFocusableElement =
    this.focusableElements[this.focusableElements.length - 1] || this.button;
};

FrontPageMobileMenu.prototype.prepareSubmenus = function () {
  var submenuItems;
  var index;

  if (!this.sidebar) {
    return;
  }

  submenuItems = this.sidebar.querySelectorAll(this.submenuItemSelector);

  for (index = 0; index < submenuItems.length; index += 1) {
    this.setSubmenuState(submenuItems[index], false);
  }
};

FrontPageMobileMenu.prototype.getDirectSubmenu = function (menuItem) {
  var children;
  var index;

  if (!menuItem) {
    return null;
  }

  children = menuItem.children;

  for (index = 0; index < children.length; index += 1) {
    if (children[index].tagName === 'UL' && children[index].classList.contains('sub-menu')) {
      return children[index];
    }
  }

  return null;
};

FrontPageMobileMenu.prototype.getSubmenuParentFromLink = function (link) {
  var parentItem = link ? link.parentNode : null;
  var submenu = null;

  if (!parentItem || parentItem.tagName !== 'LI') {
    return null;
  }

  if (!parentItem.classList.contains('menu-item-has-children')) {
    return null;
  }

  submenu = this.getDirectSubmenu(parentItem);

  if (!submenu) {
    return null;
  }

  return parentItem;
};

FrontPageMobileMenu.prototype.setSubmenuState = function (menuItem, isOpen) {
  var link;
  var submenu;

  if (!menuItem) {
    return;
  }

  link = this.getDirectLink(menuItem);
  submenu = this.getDirectSubmenu(menuItem);

  if (!link || link.tagName !== 'A' || !submenu) {
    return;
  }

  menuItem.classList.toggle(this.submenuOpenClass, isOpen);
  link.setAttribute('aria-haspopup', 'true');
  link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  submenu.hidden = !isOpen;
};

FrontPageMobileMenu.prototype.closeSiblingSubmenus = function (menuItem) {
  var siblings;
  var index;

  if (!menuItem || !menuItem.parentNode) {
    return;
  }

  siblings = menuItem.parentNode.children;

  for (index = 0; index < siblings.length; index += 1) {
    if (siblings[index] !== menuItem) {
      this.setSubmenuState(siblings[index], false);
    }
  }
};

FrontPageMobileMenu.prototype.collapseSubmenus = function () {
  this.prepareSubmenus();
};

FrontPageMobileMenu.prototype.toggleSubmenuForLink = function (link, event) {
  var menuItem;
  var isOpen;

  if (window.innerWidth > MOBILE_BREAKPOINT) {
    return false;
  }

  menuItem = this.getSubmenuParentFromLink(link);

  if (!menuItem) {
    return false;
  }

  if (event) {
    event.preventDefault();
  }

  isOpen = menuItem.classList.contains(this.submenuOpenClass);

  if (isOpen) {
    this.setSubmenuState(menuItem, false);
  } else {
    this.closeSiblingSubmenus(menuItem);
    this.setSubmenuState(menuItem, true);
  }

  this.refreshFocusableElements();
  return true;
};

FrontPageMobileMenu.prototype.maintainFocus = function (event) {
  if (!this.firstFocusableElement || !this.lastFocusableElement) {
    return;
  }

  if (event.shiftKey && document.activeElement === this.firstFocusableElement) {
    event.preventDefault();
    this.lastFocusableElement.focus();
    return;
  }

  if (!event.shiftKey && document.activeElement === this.lastFocusableElement) {
    event.preventDefault();
    this.firstFocusableElement.focus();
  }
};

function bootFrontPageMobileMenu() {
  var mobileMenu = new FrontPageMobileMenu({
    rootSelector: '.main__navigation-section',
    buttonSelector: '.main__navigation__mobile-menu-button',
    closeButtonSelector: '.main__navigation__mobile-close-button',
    sidebarSelector: '.main__navigation__mobile-sidebar',
    panelSelector: '.main__navigation__mobile-sidebar-panel',
    menuLinkSelector: '.main__navigation__mobile-menu a',
    activeClass: 'main__navigation-section--menu-open',
    bodyClass: 'front-page-mobile-menu-open',
  });

  mobileMenu.init();
}

function ScrollToTop(options) {
  this.buttonSelector = options.buttonSelector;
  this.visibleClass = options.visibleClass;

  this.button = document.querySelector(this.buttonSelector);

  this.handleClick = this.handleClick.bind(this);
  this.handleScroll = this.handleScroll.bind(this);
  this.handleResize = this.handleResize.bind(this);
}

ScrollToTop.prototype.init = function () {
  if (!this.button) {
    return;
  }

  this.button.setAttribute('hidden', 'hidden');
  this.button.setAttribute('aria-hidden', 'true');
  this.bindEvents();
  this.updateVisibility();
};

ScrollToTop.prototype.bindEvents = function () {
  this.button.addEventListener('click', this.handleClick);
  window.addEventListener('scroll', this.handleScroll, { passive: true });
  window.addEventListener('resize', this.handleResize, { passive: true });
};

ScrollToTop.prototype.getViewportHeight = function () {
  if (window.visualViewport && window.visualViewport.height) {
    return window.visualViewport.height;
  }

  return window.innerHeight || document.documentElement.clientHeight || 0;
};

ScrollToTop.prototype.pageSupportsScrollToTop = function () {
  var viewportHeight = this.getViewportHeight();
  var pageHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );

  return viewportHeight > 0 && pageHeight >= viewportHeight * 2;
};

ScrollToTop.prototype.currentScrollTop = function () {
  return window.pageYOffset || document.documentElement.scrollTop || 0;
};

ScrollToTop.prototype.shouldShowButton = function () {
  var viewportHeight = this.getViewportHeight();
  return this.pageSupportsScrollToTop() && this.currentScrollTop() >= viewportHeight;
};

ScrollToTop.prototype.updateVisibility = function () {
  if (this.shouldShowButton()) {
    this.button.hidden = false;
    this.button.removeAttribute('aria-hidden');
    this.button.classList.add(this.visibleClass);
    return;
  }

  this.button.classList.remove(this.visibleClass);
  this.button.setAttribute('aria-hidden', 'true');
  this.button.hidden = true;
};

ScrollToTop.prototype.handleScroll = function () {
  this.updateVisibility();
};

ScrollToTop.prototype.handleResize = function () {
  this.updateVisibility();
};

ScrollToTop.prototype.handleClick = function () {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

function bootScrollToTop() {
  var scrollToTop = new ScrollToTop({
    buttonSelector: '#scroll-to-top',
    visibleClass: 'scroll-to-top--visible',
  });

  scrollToTop.init();
}

function NavWidthSetter(options) {
  this.selector = options.selector;
  this.el = document.querySelector(this.selector);
  this.debounceTimeout = null;
  this.handleResize = this.handleResize.bind(this);
}

NavWidthSetter.prototype.init = function () {
  if (!this.el) {
    return;
  }

  this.setWidth();
  window.addEventListener('resize', this.handleResize, { passive: true });
};

NavWidthSetter.prototype.setWidth = function () {
  var width = this.el.offsetWidth;
  console.log(this.el);
  console.log(width);
  document.documentElement.style.setProperty('--aderbal-nav-width', width + 'px');
  if (document.body && !document.body.classList.contains('nav-width-set')) {
    document.body.classList.add('nav-width-set');
  }
};

NavWidthSetter.prototype.handleResize = function () {
  var self = this;
  if (this.debounceTimeout) {
    clearTimeout(this.debounceTimeout);
  }
  this.debounceTimeout = setTimeout(function () {
    self.setWidth();
  }, 150);
};

function bootNavWidthSetter() {
  var setter = new NavWidthSetter({ selector: '.main__navigation-bar' });
  setter.init();
}

document.addEventListener('DOMContentLoaded', function () {
  bootFrontPageMobileMenu();
  bootScrollToTop();

  setTimeout(function () {
    bootNavWidthSetter();
  }, 300);
});
